import { render, staticRenderFns } from "./Jiangshilist.vue?vue&type=template&id=5fb52115&scoped=true"
import script from "./Jiangshilist.vue?vue&type=script&lang=js"
export * from "./Jiangshilist.vue?vue&type=script&lang=js"
import style0 from "./Jiangshilist.vue?vue&type=style&index=0&id=5fb52115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb52115",
  null
  
)

export default component.exports